// Map the originating brand site's return_to_url back to a brand identity.
// The CheckoutSession stores return_to_url like "https://themetal.store/checkout/success";
// we derive the brand from the hostname so the checkout + confirmation pages
// can show the right brand name + a working "Return to {Brand}" CTA.

const BRANDS = [
  {
    hostMatch: /(?:^|\.)themetal\.store$/i,
    slug: 'themetalstore',
    name: 'The Metal Store',
    origin: 'https://themetal.store',
    accent: '#111827',
  },
  {
    hostMatch: /(?:^|\.)justbathrooms\.in$/i,
    slug: 'just-bathrooms',
    name: 'Just Bathrooms',
    origin: 'https://www.justbathrooms.in',
    accent: '#C9A467',
  },
  {
    hostMatch: /(?:^|\.)themarvel\.homes$/i,
    slug: 'marvel-homes',
    name: 'Marvel Homes',
    origin: 'https://www.themarvel.homes',
    accent: '#E91E78',
  },
  {
    hostMatch: /(?:^|\.)vantage\.best$/i,
    slug: 'vantage',
    name: 'Vantage',
    origin: 'https://www.vantage.best',
    accent: '#F7A134',
  },
];

export function brandFromReturnUrl(url) {
  if (!url || typeof url !== 'string') return null;
  let host;
  try {
    host = new URL(url).host;
  } catch {
    return null;
  }
  const hit = BRANDS.find((b) => b.hostMatch.test(host));
  if (!hit) return null;
  return {
    slug: hit.slug,
    name: hit.name,
    origin: hit.origin,
    accent: hit.accent,
    returnUrl: url,
  };
}
